// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collapse-faq p{margin-bottom:1rem}.collapse-faq p,.collapse-faq span{color:var(--tm-text-color)!important}.collapse-faq a{--tw-text-opacity:1;color:hsla(var(--p) / var(--tw-text-opacity))}.collapse-faq a:hover{opacity:0.6}.tm-question__wrapper p{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
